// extracted by mini-css-extract-plugin
export default {"documentName":"documentViewer_documentName__5qTR8","documentCaption":"documentViewer_documentCaption__emWQV"};